// apiFetch — drop-in replacement for the platform fetch() used by every data
// hook. Same signature, same Response returned (callers' existing res.ok /
// res.status handling is unchanged) — the only addition is reporting a 401
// through authEvents.ts so AuthProvider can clear auth state and force a
// clean re-login, instead of each hook silently failing on its own. See
// authEvents.ts for the full rationale (design-review followup, 2026-07-07).
import { reportUnauthorized } from "./authEvents";

export async function apiFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const res = await fetch(input, init);
  if (res.status === 401) {
    reportUnauthorized();
  }
  return res;
}
